import React, { useContext, useState } from 'react';
import { Modal } from 'react-bootstrap';
import constants from '../../constants/constants';
import { ConfigContext } from '../../providers/ConfigContext';
import styles from './ExternalLogin.module.scss';
import { updateLogInData } from '../../DumbleData';
import styled from 'styled-components';

interface Props {
	fairId: string | (string | null)[] | null;
	setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
	handleRedirect?: string;
}

const ExternalLogin = ({ fairId, setLoggedIn, handleRedirect }: Props) => {
	const { logInUrl } = useContext(ConfigContext);
	const signInUrl = logInUrl + constants.login;
	const [show, setShow] = useState(true);

	window.addEventListener(
		'message',
		(event: any) => {
			callbackLogin(event);
		},
		true
	);

	const callbackLogin = (event: MessageEvent) => {
		if (event && event.origin === logInUrl) {
			const { status, data } = JSON.parse(event.data);
			if (status === 'SUCCESS') {
				setShow(false);
				setLoggedIn(true);
				updateLogInData();
				if (handleRedirect) {
					window.location.replace(handleRedirect);
				} else {
					window.location.replace(fairId ? `/?fairId=${fairId}` : '/');
				}
				return;
			} else if (status === 'REDIRECT') {
				console.log(status, data);
			} else if (status === 'RESET') {
				console.log(status, data);
				//we do nothing here bc reset link will come through email
			}
		}
	};

	return (
		<div className={styles.ExternalLogin} data-testid="ExternalLogin">
			<Modal show={show}>
				<div className={styles.extLogin}>
					<StyledIframe id="loginModal" src={signInUrl} title="Login Modal" />
				</div>
			</Modal>
		</div>
	);
};

const StyledIframe = styled.iframe`
	box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.2);
	border: none;
	width: 70vw;
	height: 89vh;
`;

export default ExternalLogin;
